import { render, staticRenderFns } from "./ecopPage.vue?vue&type=template&id=00ee66f4&"
import script from "./ecopPage.vue?vue&type=script&lang=js&"
export * from "./ecopPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports